<template>
  <div class="sub-tarefa-inputs-pai">
    <div class="sub-tarefa-inputs">
      <div class="sub-tarefa-inputs-top">
        <h6>ESCOLHA O FORMULÁRIO</h6>

        <h6 style="cursor: pointer" @click="fecharModal()">X</h6>
      </div>

      <div class="sub-tarefa-all-inputs">
        <div class="btns">
          <div class="subTarefa-titulo-input-aviso">
            <i class="fa-solid fa-file-lines fa-3x" style="color: #3a2474"></i>

            <h4>Qual formulário de parceria você deseja preencher?</h4>

            <p>Selecione uma das opções abaixo para continuar</p>
          </div>
        </div>

        <div class="modal-opcoes">
          <button class="opcao-formulario" @click="acessarFormularioExterno()">
            <div class="opcao-formulario-titulo">
              <strong>Parceria Externa para Ações de Extensão</strong>

              <i class="fa-solid fa-chevron-right"></i>
            </div>

            <span>
              Para coordenadores(as) de ações de extensão que desejam
              estabelecer parceria com entidades externas à UFC, como órgãos
              públicos, escolas, ONGs/OSCs ou empresas.
            </span>
          </button>

          <button class="opcao-formulario" @click="acessarFormularioInterno()">
            <div class="opcao-formulario-titulo">
              <strong
                >Parceria Interna (Intra Muros) para Ações de Extensão</strong
              >

              <i class="fa-solid fa-chevron-right"></i>
            </div>

            <span>
              Para coordenadores(as) de ações de extensão que desejam articular
              parceria com outra unidade, centro, instituto ou campus da própria
              UFC.
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits([
  "fecharModal",
  "formularioExterno",
  "formularioInterno",
]);

function fecharModal() {
  emit("fecharModal");
}

function acessarFormularioExterno() {
  emit("formularioExterno");
}

function acessarFormularioInterno() {
  emit("formularioInterno");
}
</script>

<style scoped>
.sub-tarefa-inputs-pai {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.sub-tarefa-inputs {
  background-color: #ffffff;
  border: none;
  border-radius: 12px;
  width: 500px;
  max-width: 90vw;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sub-tarefa-inputs-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #3a2474;
  padding: 12px 0;
  position: relative;
  min-height: 46px;
}

.sub-tarefa-inputs-top h6:first-child {
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  margin: 0;
  text-align: center;
  letter-spacing: 0.5px;
}

.sub-tarefa-inputs-top h6:last-child {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 14px;
  background-color: #3a2474;
  color: #ffffff;
  margin: 0;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 0 12px 0 0;
  min-width: 38px;
}

.sub-tarefa-inputs-top h6:last-child:hover {
  background-color: #2e1a5e;
}

.sub-tarefa-all-inputs {
  padding: 30px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.subTarefa-titulo-input-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 14px;
}

.subTarefa-titulo-input-aviso h4 {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  text-align: center;
}

.subTarefa-titulo-input-aviso p {
  font-size: 14px;
  color: #666666;
  margin: 0;
  text-align: center;
  line-height: 1.5;
}

.modal-opcoes {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}

.opcao-formulario {
  width: 100%;
  border: 1px solid #d8d4e6;
  border-radius: 10px;
  padding: 16px 18px;
  background-color: #ffffff;
  color: #333333;
  text-align: left;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  gap: 9px;

  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
}

.opcao-formulario:hover {
  background-color: #faf8ff;
  border-color: #7c3aed;
  transform: translateY(-1px);
}

.opcao-formulario:focus-visible {
  outline: 2px solid #7c3aed;
  outline-offset: 2px;
}

.opcao-formulario-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.opcao-formulario-titulo strong {
  color: #3a2474;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
}

.opcao-formulario-titulo i {
  color: #7c3aed;
  font-size: 13px;
  flex-shrink: 0;
}

.opcao-formulario span {
  display: block;
  color: #666666;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 500px) {
  .sub-tarefa-inputs {
    width: 90vw;
  }

  .sub-tarefa-all-inputs {
    padding: 26px 18px 22px;
  }

  .opcao-formulario {
    padding: 14px;
  }

  .opcao-formulario-titulo strong {
    font-size: 13px;
  }

  .opcao-formulario span {
    font-size: 12px;
  }
}
</style>
